import createIcon from '../../createIcon';

/**
 * @component @name NoEncryption
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgMjEuNzhMNC4yMiA1TDMgNi4yMkw1LjA0IDguMjZDNC40MiA4LjYgNCA5LjI1IDQgMTBWMjBDNCAyMS4xIDQuOSAyMiA2IDIySDE4QzE4LjIzIDIyIDE4LjQ1IDIxLjk1IDE4LjY2IDIxLjg4TDE5Ljc4IDIzTDIxIDIxLjc4Wk04LjkgNkM4LjkgNC4yOSAxMC4yOSAyLjkgMTIgMi45QzEzLjcxIDIuOSAxNS4xIDQuMjkgMTUuMSA2VjhIOS42NkwyMCAxOC4zNFYxMEMyMCA4LjkgMTkuMSA4IDE4IDhIMTdWNkMxNyAzLjI0IDE0Ljc2IDEgMTIgMUM5LjQ0IDEgNy4zNiAyLjkzIDcuMDYgNS40TDguOSA3LjI0VjZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const NoEncryption = createIcon('NoEncryption', [
  [
    'path',
    {
      d: 'M21 21.78L4.22 5L3 6.22L5.04 8.26C4.42 8.6 4 9.25 4 10V20C4 21.1 4.9 22 6 22H18C18.23 22 18.45 21.95 18.66 21.88L19.78 23L21 21.78ZM8.9 6C8.9 4.29 10.29 2.9 12 2.9C13.71 2.9 15.1 4.29 15.1 6V8H9.66L20 18.34V10C20 8.9 19.1 8 18 8H17V6C17 3.24 14.76 1 12 1C9.44 1 7.36 2.93 7.06 5.4L8.9 7.24V6Z',
      key: '1d393a',
    },
  ],
]);

export default NoEncryption;
